import { pascalCaseToWords } from '../../../app/common/common-utils';
import { EntityType } from '../../enums/entity-type';
import { DiffField } from '../internal/diffs/diff-field';
import { PropertyUpdateInfo } from './property-update-info';

export class EntityPropertyUpdateSynchronisationInfo {
  private readonly _machineFieldsAffected?: boolean;
  private readonly _documentationFieldsAffected?: boolean;
  private readonly _isEditedEntity?: boolean;
  private readonly _entityId?: string;
  private readonly _entityType?: EntityType;
  private readonly _swPartNumber?: string;
  private readonly _properties?: PropertyUpdateInfo[];

  constructor(
    machineFieldsAffected?: boolean,
    documentationFieldsAffected?: boolean,
    isEditedEntity?: boolean,
    entityId?: string,
    entityType?: EntityType,
    swPartNumber?: string,
    properties?: PropertyUpdateInfo[]
  ) {
    this._machineFieldsAffected = machineFieldsAffected;
    this._documentationFieldsAffected = documentationFieldsAffected;
    this._isEditedEntity = isEditedEntity;
    this._entityId = entityId;
    this._entityType = entityType;
    this._swPartNumber = swPartNumber;
    this._properties = properties;
  }

  public get machineFieldsAffected(): boolean {
    return this._machineFieldsAffected ?? false;
  }

  public get documentationFieldsAffected(): boolean {
    return this._documentationFieldsAffected ?? false;
  }

  public get isEditedEntity(): boolean {
    return this._isEditedEntity ?? false;
  }

  public get entityId(): string {
    return this._entityId ?? '';
  }

  public get entityType(): EntityType | undefined {
    return this._entityType;
  }

  public get swPartNumber(): string {
    return this._swPartNumber ?? '';
  }

  public get properties(): PropertyUpdateInfo[] {
    return this._properties ?? [];
  }

  public getPropertyByName(propertyName: string): PropertyUpdateInfo | undefined {
    const requestedProperty = pascalCaseToWords(propertyName);
    return this.properties.find((property) => pascalCaseToWords(property.propertyName || '') === requestedProperty);
  }

  public getPropertyUpdateDiffField(propertyName: string): DiffField {
    const property = this.getPropertyByName(propertyName);
    const diffField = new DiffField();
    if (propertyName === 'Error Message') {
      diffField.buildLineDiff('', property?.previousValue, property?.updatedValue);
    } else {
      diffField.buildDiff('', property?.previousValue, property?.updatedValue);
    }
    return diffField;
  }
}
